var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 14L31 10.0718V23.9282L25 20V14Z",
    fill: "#0071FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7071 5.29289C26.0976 5.68342 26.0976 6.31658 25.7071 6.70711L3.70711 28.7071C3.31658 29.0976 2.68342 29.0976 2.29289 28.7071C1.90237 28.3166 1.90237 27.6834 2.29289 27.2929L24.2929 5.29289C24.6834 4.90237 25.3166 4.90237 25.7071 5.29289Z",
    fill: "#0071FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1681 8.00347C20.1124 8.00116 20.0563 8 20 8H7C4.79086 8 3 9.79086 3 12V22C3 22.8933 3.29281 23.7181 3.78768 24.3839L20.1681 8.00347Z",
    fill: "#0071FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82843 26H20C22.2091 26 24 24.2091 24 22V12C24 11.3672 23.8531 10.7688 23.5915 10.2369L7.82843 26Z",
    fill: "#0071FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/cameraOff.f23c9aaf5337ebc91680b1883e2d4797.svg";
export { ForwardRef as ReactComponent };